import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BookYourCandiacService() {
  return <section data-section-id="252582" id="צרו-קשר-עכשיו-מטפל-סיעודי-בירושלים" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="bg-primary text-primary-foreground rounded-lg p-8 md:p-16 flex flex-col items-center text-center gap-8 shadow-xl">
          <div className="space-y-4 max-w-3xl">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
              זקוקים לעזרה דחופה? מטפל סיעודי בירושלים עכשיו
            </h2>
            <p className="font-default text-lg md:text-xl opacity-90">
              אנחנו כאן כדי לספק פתרון מיידי עם מטפל סיעודי ישראלי מקצועי ומסור. אל תישארו לבד ברגעים הקריטיים – הצוות שלנו ערוך להגיע אליכם תוך שעות ספורות.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Link to="/ContactPage">
              <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-lg font-semibold rounded-md bg-secondary text-secondary-foreground hover:opacity-90 transition-opacity">
                <SafeHydrate><Calendar className="ml-2 size-5" /></SafeHydrate>
                התקשרו עכשיו לייעוץ
              </Button>
            </Link>
            <Link to="/NursingCareProviderInJerusalemWithinFiveHoursPage">
              <Button variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-lg font-semibold rounded-md border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary transition-colors">
                למידע על פתרון מיידי
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}